import { Dispatch } from "react-redux";
import { IApplicationState } from "@nkr/store/index";
import { AuthActionCreators } from "../authorization/index";   //IPost

export interface IArchiveInfoResponse {
    data: {
        success: number,
        message: string,
        results: {
            username: string,
            password: string,
            url: string
        }
    }
}


export const ActionCreators = {
    getArchiveInfo: () => async (dispatch: Dispatch<IApplicationState>): Promise<IArchiveInfoResponse> => {
        var options = {
            url: 'https://outlook.office.com/mail/archive@kidneyregistry.com/'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    }
}